var map = {
	"./all-you-can-eat-ordering-system/metadata": [
		5025,
		5025
	],
	"./bakery-ordering-software/metadata": [
		2768,
		2768
	],
	"./bowling-alley-digital-ordering/metadata": [
		8047,
		8047
	],
	"./choosing-ordering-solution/metadata": [
		735,
		735
	],
	"./golf-clubs-digital-ordering/metadata": [
		1332,
		1332
	],
	"./hotel-digital-ordering/metadata": [
		8633,
		8633
	],
	"./qr-ordering-restaurant-guide/metadata": [
		8140,
		8140
	],
	"./restaurant-kpi-guide/metadata": [
		6619,
		6619
	],
	"./self-order-kiosks-for-hospitality/metadata": [
		9913,
		9913
	],
	"./snackbar-digital-ordering/metadata": [
		8466,
		8466
	],
	"./the-new-hospitality-industry/metadata": [
		2275,
		2275
	],
	"./the-psychology-behind-upselling/metadata": [
		4343,
		4343
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2547;
module.exports = webpackAsyncContext;